<div class="content-body">
  <app-breadcrumb [breadcrumb]="breadcrumbList"></app-breadcrumb>
  <div class="container-fluid">
    <div class="card">
      <div class="card-body p-0">
        <!-- Filters Section -->
        <form [formGroup]="filterForm" autocomplete="off">
          <div class="row p-3">
            <div class="col-md-2">
              <label class="form-label">Start Date</label>
              <input type="date" class="form-control form-control-sm" formControlName="start_date" (change)="onFilterChange()">
            </div>
            <div class="col-md-2">
              <label class="form-label">End Date</label>
              <input type="date" class="form-control form-control-sm" formControlName="end_date"
                     [min]="filterForm.get('start_date')?.value" (change)="onFilterChange()">
            </div>
            <div class="col-md-2">
              <label class="form-label">Property</label>
              <ng-select ngDefaultControl
                         [items]="propertiesItems"
                         placeholder="Select Property"
                         class="select2 select2-sm"
                         formControlName="property_id"
                         [typeahead]="searchProperty$"
                         [virtualScroll]="true"
                         (scrollToEnd)="onPropertyScrollEnd()"
                         (change)="onFilterChange()">
                <ng-template ng-label-tmp let-item="item">{{item.label}}</ng-template>
                <ng-template ng-option-tmp let-item="item">{{item.label}}</ng-template>
              </ng-select>
            </div>
            <div class="col-md-2">
              <label class="form-label">Managed By</label>
              <ng-select ngDefaultControl
                         [items]="managersItems"
                         placeholder="Select Manager"
                         class="select2 select2-sm"
                         formControlName="managed_by"
                         [multiple]="true"
                         [closeOnSelect]="false"
                         [typeahead]="searchManager$"
                         [virtualScroll]="true"
                         (scrollToEnd)="onManagerScrollEnd()"
                         (change)="onFilterChange()">
                <ng-template ng-label-tmp let-item="item">{{item.label}}</ng-template>
                <ng-template ng-option-tmp let-item="item">{{item.label}}</ng-template>
              </ng-select>
            </div>
            <div class="col-md-2">
              <label class="form-label">Status</label>
              <ng-select ngDefaultControl
                         [items]="statusOptions"
                         bindValue="value"
                         bindLabel="label"
                         placeholder="Select Status"
                         class="select2 select2-sm"
                         formControlName="status"
                         (change)="onFilterChange()">
              </ng-select>
            </div>
            <div class="col-md-2">
              <label class="form-label">Inspection Type</label>
              <ng-select ngDefaultControl
                         [items]="inspectionTypeOptions"
                         bindValue="value"
                         bindLabel="label"
                         placeholder="Select Type"
                         class="select2 select2-sm"
                         formControlName="inspection_type"
                         (change)="onFilterChange()">
              </ng-select>
            </div>
          </div>
          <div class="row px-3 pb-3">
            <div class="col-md-12 d-flex justify-content-end">
              <button class="btn btn-danger btn-sm" type="button" (click)="resetFilters()" [disabled]="!disableClear">
                Clear Filters
              </button>
            </div>
          </div>
        </form>

        <!-- Summary Cards -->
        <div class="row px-3 pb-3" *ngIf="summaryData">
          <div class="col-md-12">
            <div class="d-flex flex-wrap gap-2">
              <div class="summary-card bg-primary text-white">
                <div class="summary-value">{{ summaryData.total_inspections }}</div>
                <div class="summary-label">Total Inspections</div>
              </div>
              <ng-container *ngFor="let key of getSummaryKeys(summaryData.count_by_status)">
                <div class="summary-card" [ngClass]="{
                  'bg-warning': key === 'In Progress',
                  'bg-info': key === 'Submitted',
                  'bg-success text-white': key === 'Completed',
                  'bg-secondary text-white': key === 'Tenant Review' || key === 'Owner Review' || key === 'unknown'
                }">
                  <div class="summary-value">{{ summaryData.count_by_status[key] }}</div>
                  <div class="summary-label">{{ key }}</div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>

        <!-- Tabs -->
        <ul class="nav nav-tabs" role="tablist">
          <li class="nav-item" role="presentation">
            <button class="nav-link" [class.active]="activeTab === 'all'" (click)="switchTab('all')" type="button">
              All Inspections
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" [class.active]="activeTab === 'by-manager'" (click)="switchTab('by-manager')" type="button">
              By Manager
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" [class.active]="activeTab === 'graphs'" (click)="switchTab('graphs')" type="button">
              Graphs
            </button>
          </li>
        </ul>

        <!-- Tab Content -->
        <div class="tab-content">
          <!-- All Inspections Tab -->
          <div class="tab-pane" [class.active]="activeTab === 'all'" [class.show]="activeTab === 'all'">
            <div class="table-responsive active-projects style-1 ItemsCheckboxSec shorting dataTables_wrapper">
              <div class="tbl-caption d-flex justify-content-between align-items-center p-3">
                <h4 class="heading mb-0">All Inspections Report</h4>
                <div class="d-flex gap-2" *ngIf="checkDownloadPermission">
                  <button class="btn btn-outline-primary btn-sm" (click)="downloadReport('pdf')" [disabled]="isDownloading">
                    <span *ngIf="activeDownloadType !== 'pdf'">PDF</span>
                    <span *ngIf="activeDownloadType === 'pdf'">{{ downloadProgress }}</span>
                  </button>
                  <button class="btn btn-outline-success btn-sm" (click)="downloadReport('csv')" [disabled]="isDownloading">
                    <span *ngIf="activeDownloadType !== 'csv'">CSV</span>
                    <span *ngIf="activeDownloadType === 'csv'">{{ downloadProgress }}</span>
                  </button>
                  <button class="btn btn-outline-info btn-sm" (click)="openShareModal('email')" [disabled]="isDownloading">
                    <span *ngIf="activeDownloadType !== 'email'">Email</span>
                    <span *ngIf="activeDownloadType === 'email'">{{ downloadProgress }}</span>
                  </button>
                  <button class="btn btn-outline-secondary btn-sm" (click)="openShareModal('whatsapp')" [disabled]="isDownloading">
                    <span *ngIf="activeDownloadType !== 'whatsapp'">WhatsApp</span>
                    <span *ngIf="activeDownloadType === 'whatsapp'">{{ downloadProgress }}</span>
                  </button>
                </div>
              </div>
              <table class="table mb-0">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Property</th>
                    <th>Inspection Name</th>
                    <th>Type</th>
                    <th>Scheduled Date</th>
                    <th>Completed Date</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  @for(item of allInspectionsData; track item.id; let i = $index) {
                    <tr>
                      <td>{{ (pageAll - 1) * totalRowsAll + i + 1 }}</td>
                      <td>{{ item.property_name }}</td>
                      <td>{{ item.inspection_name }}</td>
                      <td>{{ item.inspection_type }}</td>
                      <td>{{ item.scheduled_date | date:'dd-MM-yyyy' }}</td>
                      <td>{{ item.completed_date ? (item.completed_date | date:'dd-MM-yyyy') : '-' }}</td>
                      <td>
                        <span class="badge" [ngClass]="getStatusClass(item.status)">{{ item.status }}</span>
                      </td>
                    </tr>
                  }
                  @if(allInspectionsData.length === 0) {
                    <tr>
                      <td colspan="7" class="text-center py-4">No data found</td>
                    </tr>
                  }
                </tbody>
              </table>
              <div class="d-flex justify-content-between align-items-center p-3">
                <div class="dataTables_info">
                  Showing {{ (pageAll - 1) * totalRowsAll + 1 }} to {{ Math.min(pageAll * totalRowsAll, totalPageAll) }} of {{ totalPageAll }} entries
                </div>
                <div class="dataTables_paginate">
                  <app-pagination [totalPage]="pageCountAll" [page]="pageAll" (newPage)="pageChangeAll($event)"></app-pagination>
                </div>
              </div>
            </div>
          </div>

          <!-- By Manager Tab -->
          <div class="tab-pane" [class.active]="activeTab === 'by-manager'" [class.show]="activeTab === 'by-manager'">
            <div class="table-responsive active-projects style-1 ItemsCheckboxSec shorting dataTables_wrapper">
              <div class="tbl-caption d-flex justify-content-between align-items-center p-3">
                <h4 class="heading mb-0">Inspections By Manager</h4>
                <div class="d-flex gap-2" *ngIf="checkDownloadPermission">
                  <button class="btn btn-outline-primary btn-sm" (click)="downloadReport('pdf')" [disabled]="isDownloading">
                    <span *ngIf="activeDownloadType !== 'pdf'">PDF</span>
                    <span *ngIf="activeDownloadType === 'pdf'">{{ downloadProgress }}</span>
                  </button>
                  <button class="btn btn-outline-success btn-sm" (click)="downloadReport('csv')" [disabled]="isDownloading">
                    <span *ngIf="activeDownloadType !== 'csv'">CSV</span>
                    <span *ngIf="activeDownloadType === 'csv'">{{ downloadProgress }}</span>
                  </button>
                  <button class="btn btn-outline-info btn-sm" (click)="openShareModal('email')" [disabled]="isDownloading">
                    <span *ngIf="activeDownloadType !== 'email'">Email</span>
                    <span *ngIf="activeDownloadType === 'email'">{{ downloadProgress }}</span>
                  </button>
                  <button class="btn btn-outline-secondary btn-sm" (click)="openShareModal('whatsapp')" [disabled]="isDownloading">
                    <span *ngIf="activeDownloadType !== 'whatsapp'">WhatsApp</span>
                    <span *ngIf="activeDownloadType === 'whatsapp'">{{ downloadProgress }}</span>
                  </button>
                </div>
              </div>
              <table class="table mb-0">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Manager Name</th>
                    <th class="text-center">In Progress</th>
                    <th class="text-center">Submitted</th>
                    <th class="text-center">Completed</th>
                    <th class="text-center">Tenant Review</th>
                    <th class="text-center">Owner Review</th>
                    <th class="text-center">Total</th>
                  </tr>
                </thead>
                <tbody>
                  @for(item of byManagerData; track item.manager_id; let i = $index) {
                    <tr>
                      <td>{{ (pageByManager - 1) * totalRowsByManager + i + 1 }}</td>
                      <td>{{ item.manager_name }}</td>
                      <td class="text-center">
                        <span class="badge badge-warning">{{ item.in_progress }}</span>
                      </td>
                      <td class="text-center">
                        <span class="badge badge-info">{{ item.submitted }}</span>
                      </td>
                      <td class="text-center">
                        <span class="badge badge-success">{{ item.completed }}</span>
                      </td>
                      <td class="text-center">
                        <span class="badge badge-secondary">{{ item.tenant_review }}</span>
                      </td>
                      <td class="text-center">
                        <span class="badge badge-secondary">{{ item.owner_review }}</span>
                      </td>
                      <td class="text-center">
                        <strong>{{ item.total }}</strong>
                      </td>
                    </tr>
                  }
                  @if(byManagerData.length === 0) {
                    <tr>
                      <td colspan="8" class="text-center py-4">No data found</td>
                    </tr>
                  }
                </tbody>
              </table>
              <div class="d-flex justify-content-between align-items-center p-3">
                <div class="dataTables_info">
                  Showing {{ (pageByManager - 1) * totalRowsByManager + 1 }} to {{ Math.min(pageByManager * totalRowsByManager, totalPageByManager) }} of {{ totalPageByManager }} entries
                </div>
                <div class="dataTables_paginate">
                  <app-pagination [totalPage]="pageCountByManager" [page]="pageByManager" (newPage)="pageChangeByManager($event)"></app-pagination>
                </div>
              </div>
            </div>
          </div>

          <!-- Graphs Tab -->
          <div class="tab-pane" [class.active]="activeTab === 'graphs'" [class.show]="activeTab === 'graphs'">
            <div class="p-4">
              <div class="row" *ngIf="summaryData">
                <!-- Status Distribution Chart -->
                <div class="col-md-6 mb-4">
                  <div class="card">
                    <div class="card-header">
                      <h5 class="mb-0">Inspections by Status</h5>
                    </div>
                    <div class="card-body">
                      <div class="chart-container">
                        <div class="chart-bars">
                          @for(key of getSummaryKeys(summaryData.count_by_status); track key) {
                            <div class="chart-bar-item">
                              <div class="chart-bar-label">{{ key }}</div>
                              <div class="chart-bar-wrapper">
                                <div class="chart-bar"
                                     [style.width.%]="(summaryData.count_by_status[key] / summaryData.total_inspections) * 100"
                                     [ngClass]="{
                                       'bg-warning': key === 'In Progress',
                                       'bg-info': key === 'Submitted',
                                       'bg-success': key === 'Completed',
                                       'bg-secondary': key === 'Tenant Review' || key === 'Owner Review' || key === 'unknown'
                                     }">
                                </div>
                                <span class="chart-bar-value">{{ summaryData.count_by_status[key] }}</span>
                              </div>
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Type Distribution Chart -->
                <div class="col-md-6 mb-4">
                  <div class="card">
                    <div class="card-header">
                      <h5 class="mb-0">Inspections by Type</h5>
                    </div>
                    <div class="card-body">
                      <div class="chart-container">
                        <div class="chart-bars">
                          @for(key of getSummaryKeys(summaryData.count_by_type); track key) {
                            <div class="chart-bar-item">
                              <div class="chart-bar-label">{{ key }}</div>
                              <div class="chart-bar-wrapper">
                                <div class="chart-bar bg-primary"
                                     [style.width.%]="(summaryData.count_by_type[key] / summaryData.total_inspections) * 100">
                                </div>
                                <span class="chart-bar-value">{{ summaryData.count_by_type[key] }}</span>
                              </div>
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Manager Performance Chart -->
                <div class="col-md-12 mb-4" *ngIf="byManagerData.length > 0">
                  <div class="card">
                    <div class="card-header">
                      <h5 class="mb-0">Manager Performance Overview</h5>
                    </div>
                    <div class="card-body">
                      <div class="chart-container">
                        <div class="chart-bars horizontal-stacked">
                          @for(manager of byManagerData; track manager.manager_id) {
                            <div class="chart-bar-item stacked">
                              <div class="chart-bar-label">{{ manager.manager_name }}</div>
                              <div class="chart-bar-stacked-wrapper">
                                <div class="stacked-bar">
                                  <div class="stacked-segment bg-success"
                                       [style.width.%]="(manager.completed / manager.total) * 100"
                                       title="Completed: {{ manager.completed }}">
                                  </div>
                                  <div class="stacked-segment bg-info"
                                       [style.width.%]="(manager.submitted / manager.total) * 100"
                                       title="Submitted: {{ manager.submitted }}">
                                  </div>
                                  <div class="stacked-segment bg-warning"
                                       [style.width.%]="(manager.in_progress / manager.total) * 100"
                                       title="In Progress: {{ manager.in_progress }}">
                                  </div>
                                  <div class="stacked-segment bg-secondary"
                                       [style.width.%]="((manager.tenant_review + manager.owner_review) / manager.total) * 100"
                                       title="Review: {{ manager.tenant_review + manager.owner_review }}">
                                  </div>
                                </div>
                                <span class="chart-bar-value">{{ manager.total }}</span>
                              </div>
                            </div>
                          }
                        </div>
                        <div class="chart-legend mt-3">
                          <span class="legend-item"><span class="legend-color bg-success"></span> Completed</span>
                          <span class="legend-item"><span class="legend-color bg-info"></span> Submitted</span>
                          <span class="legend-item"><span class="legend-color bg-warning"></span> In Progress</span>
                          <span class="legend-item"><span class="legend-color bg-secondary"></span> Review</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Download Options for Graphs -->
                <!-- <div class="col-md-12" *ngIf="checkDownloadPermission">
                  <div class="d-flex justify-content-end gap-2">
                    <button class="btn btn-outline-primary btn-sm" (click)="downloadReport('pdf')" [disabled]="isDownloading">
                      <span *ngIf="activeDownloadType !== 'pdf'">PDF</span>
                      <span *ngIf="activeDownloadType === 'pdf'">{{ downloadProgress }}</span>
                    </button>
                    <button class="btn btn-outline-success btn-sm" (click)="downloadReport('csv')" [disabled]="isDownloading">
                      <span *ngIf="activeDownloadType !== 'csv'">CSV</span>
                      <span *ngIf="activeDownloadType === 'csv'">{{ downloadProgress }}</span>
                    </button>
                    <button class="btn btn-outline-info btn-sm" (click)="openShareModal('email')" [disabled]="isDownloading">
                      <span *ngIf="activeDownloadType !== 'email'">Email</span>
                      <span *ngIf="activeDownloadType === 'email'">{{ downloadProgress }}</span>
                    </button>
                    <button class="btn btn-outline-secondary btn-sm" (click)="openShareModal('whatsapp')" [disabled]="isDownloading">
                      <span *ngIf="activeDownloadType !== 'whatsapp'">WhatsApp</span>
                      <span *ngIf="activeDownloadType === 'whatsapp'">{{ downloadProgress }}</span>
                    </button>
                  </div>
                </div> -->
              </div>

              <div *ngIf="!summaryData" class="text-center py-5">
                <p class="text-muted">No data available for graphs</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Share Modal -->
<div class="modal fade" [class.show]="showShareModal" [style.display]="showShareModal ? 'block' : 'none'" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          {{ shareType === 'email' ? 'Share via Email' : 'Share via WhatsApp' }}
        </h5>
        <button type="button" class="btn-close" (click)="closeShareModal()"></button>
      </div>
      <div class="modal-body">
        <form [formGroup]="shareForm">
          <div class="form-group mb-3">
            <label class="form-label">Report Type</label>
            <ng-select ngDefaultControl
                       [items]="reportTypeOptions"
                       bindValue="value"
                       bindLabel="label"
                       placeholder="Select Report Type"
                       class="select2 select2-sm"
                       formControlName="file_type"
                       [clearable]="false">
            </ng-select>
          </div>
          <div class="form-group mb-3">
            <label class="form-label">Select User (Optional)</label>
            <ng-select ngDefaultControl
                       [items]="managersItems"
                       placeholder="Search and select user"
                       class="select2 select2-sm"
                       formControlName="selectedUser"
                       [typeahead]="searchManager$"
                       [virtualScroll]="true"
                       (scrollToEnd)="onManagerScrollEnd()"
                       (change)="onShareUserChange($event)">
              <ng-template ng-label-tmp let-item="item">{{item.label}}</ng-template>
              <ng-template ng-option-tmp let-item="item">
                <div>{{item.label}}</div>
                <small class="text-muted" *ngIf="shareType === 'email' && item.data?.email">{{item.data.email}}</small>
                <small class="text-muted" *ngIf="shareType === 'whatsapp' && item.data?.phone">{{item.data.country_code}}{{item.data.phone}}</small>
              </ng-template>
            </ng-select>
          </div>
          <div class="row mb-3">
            <div class="col-md-6">
              <div class="form-group">
                <label class="form-label">First Name</label>
                <input type="text" class="form-control" formControlName="first_name" placeholder="Enter first name">
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label class="form-label">Last Name</label>
                <input type="text" class="form-control" formControlName="last_name" placeholder="Enter last name">
              </div>
            </div>
          </div>
          <div class="form-group" *ngIf="shareType === 'email'">
            <label class="form-label">Email Address</label>
            <input type="email" class="form-control" formControlName="email" placeholder="Enter email address">
          </div>
          <div class="row" *ngIf="shareType === 'whatsapp'">
            <div class="col-md-4">
              <div class="form-group">
                <label class="form-label">Country Code</label>
                <input type="text" class="form-control" formControlName="country_code" placeholder="+91">
              </div>
            </div>
            <div class="col-md-8">
              <div class="form-group">
                <label class="form-label">WhatsApp Number</label>
                <input type="text" class="form-control" formControlName="whatsapp" placeholder="Enter phone number">
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeShareModal()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="submitShare()">
          {{ shareType === 'email' ? 'Send Email' : 'Send WhatsApp' }}
        </button>
      </div>
    </div>
  </div>
</div>
<div class="modal-backdrop fade" [class.show]="showShareModal" *ngIf="showShareModal"></div>
